export default __webpack_public_path__ + "static/char-s-16-en-adefdc33e631996a879820949387ce29.png";